module.exports = __webpack_public_path__ + "media/images/favicon-32x32-0ae7bf061ac013818e2beace33abd67b.png";